import { keymirror } from 'app/blocks/common/utils';

const ProfileSections = keymirror({
    ADDRESSES_PROFILE: '',
    AFFILIATIONS: '',
    ALERTS_PROFILE: '',
    OPEN_ACCESS_PROFILE: '',
    ORCID: '',
    PROFILE_INFORMATION: '',
    RESEARCH_FUNDER: '',
    PREFERRED_JOURNALS: '',
    SECONDARY_EMAIL: '',
    SECURITY_QUESTIONS: '',
    SOCIETIES: '',
});

export default ProfileSections;
